import React from "react";
import HomePage from "./pages/HomePage";

const App = () =>  {
  return (
    <div className="app">
      <HomePage/>
    </div>
  );
}

export default App;
